
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/8b93f37d678e65e9c37c50c872b94975/381e684f8d6fce9ebf5debc93083afff.png" 
              alt="ND Insured Logo" 
              className="w-12 h-12 object-contain"
            />
            <div>
              <h1 className="text-2xl font-bold text-green-800" style={{ fontFamily: 'Playfair Display, serif' }}>
                ND Insured
              </h1>
              <p className="text-sm text-gray-600 font-light">Health Insurance Made Simple</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('quote')}
              className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
            >
              Get Quote
            </button>
            <a 
              href="tel:5612295893" 
              className="text-gray-700 hover:text-green-800 transition-colors flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>(561) 229-5893</span>
            </a>
            <Button 
              onClick={() => scrollToSection('quote')}
              size="sm"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-green-800 hover:bg-gray-100"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-left text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('quote')}
                className="text-left text-gray-700 hover:text-green-800 transition-colors cursor-pointer"
              >
                Get Quote
              </button>
              <a 
                href="tel:5612295893" 
                className="text-gray-700 hover:text-green-800 transition-colors flex items-center space-x-2"
              >
                <i className="ri-phone-line"></i>
                <span>(561) 229-5893</span>
              </a>
              <Button 
                onClick={() => scrollToSection('quote')}
                size="sm"
                className="w-fit"
              >
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
